/**
 * @hidden
 */
var DomEvent = /** @class */ (function () {
    /**
     * @hidden
     */
    function DomEvent(sender, e) {
        this.sender = sender;
        this.syntheticEvent = e;
    }
    return DomEvent;
}());
export { DomEvent };
function toDomEvent(sender, e) {
    return new DomEvent(sender, e);
}
export { toDomEvent };
//# sourceMappingURL=dom-event.js.map